import {Component, OnDestroy, OnInit} from '@angular/core';
import {AuthorizedApiService} from '../../services/authorized-api.service';
import {
  ChargeItem, LivesplitData, LivesplitGroup, Order,
  OrderItem, UserSpecificConfigLoyalty, UserSpecificConfigLoyaltyDiscountCode, UserSpecificConfigLoyaltyRewardTrigger
} from '../../models/Order';
import {filter, first, flatMap, tap} from 'rxjs/operators';
import {UrlHistoryService} from '../../services/url.history.service';
import {combineLatest, from, Observable, of, Subscription} from 'rxjs';
import {BamboraSession, BamboraTokenizedAuth, VivaPaymentOrder} from '../../models/PaymentModels';
import {OrderService} from '../../services/order.service';
import {ActivatedRoute, Router} from '@angular/router';
import {VenueConfig} from '../../models/FSConfig';
import {FireService} from '../../services/fire.service';
import MoneyUtils, {HackUtils, LangUtils, MenuUtils} from '../../utils/Utils';
// import {SplitItemDialogComponent} from './split-item-dialog/split-item-dialog.component';
import {MessengerService} from '../../services/messenger.service';
import {AppStateService} from '../../services/app-state.service';
import {MenuService} from "../../services/menu.service";
import {MenuItem} from "../../models/FSMenu";
import {TranslateService} from "../../services/translate.service";
import {ModalService} from '../../services/modal.service';
import {SnackbarService} from '../../services/snackbar.service';
import {UserType} from '../../models/Identity';
import {AuthService} from '../../services/auth.service';
import {FormsModule} from '@angular/forms';
import {CommonModule, NgForOf, NgIf} from '@angular/common';
import {LoadingSpinnerComponent} from '../ui/loading-spinner-component';
import {BoxForCheckboxComponent} from '../ui/box-for-checkbox.component';
import {PaymentSelectorComponent} from '../ui/payment-selector.component';
import {AppState} from '../../models/AppState';
import {PaymentInputData, PaymentOutputData, PaymentService} from '../../services/payment.service';
import {SelectCardDialogComponent} from '../dialogs/select-card-dialog.component';
import {PlainButtonComponent} from '../buttons/plain-button.component';
import {SeparatorComponent} from '../ui/separator.component';
import {TipButtonComponent} from '../buttons/tip-button.component';
import {ActionButtonComponent} from '../buttons/action-button.component';
import {ViewportService} from '../../services/viewport-service';
import {ThemeService} from '../../services/theme-service';
import {PaymentSessionService} from '../../services/payment-session.service';
import {CircleButtonComponent} from '../buttons/circle-button.component';
import {TipSelectionComponent, TipChangeEvent} from '../ui/tip-selection.component';
import {SplitItemDialogComponent} from './split-item-dialog/split-item-dialog.component';
import {LinkButtonComponent} from '../buttons/link-button.component';
import {InlineDonationsComponent} from "../common/inline-donations.component";
import {LightIconButtonComponent} from '../buttons/light-icon-button-component';
import {EnterDiscountCodeDialogComponent} from '../dialogs/enter-discount-code-dialog';
import {LoyaltyInfoComponent} from '../ui/loyalty-info.component';
import {BorderIconButtonComponent} from '../buttons/border-icon-button.component';
import {TipService} from '../../services/tip.service';
import {ActiveTipConfig} from '../../models/active-tip-config-model';

@Component({
  standalone: true,
  selector: 'app-livesplit',
  templateUrl: './livesplit.component.html',
  imports: [
    FormsModule,
    NgIf,
    NgForOf,
    LoadingSpinnerComponent,
    BoxForCheckboxComponent,
    PaymentSelectorComponent,
    PlainButtonComponent,
    SeparatorComponent,
    TipButtonComponent,
    ActionButtonComponent,
    CircleButtonComponent,
    TipSelectionComponent,
    LinkButtonComponent,
    InlineDonationsComponent,
    LightIconButtonComponent,
    LoyaltyInfoComponent,
    CommonModule,
    BorderIconButtonComponent
  ],
  styleUrls: ['./livesplit.component.css']
})
export class LivesplitComponent implements OnInit, OnDestroy {
  isLoading = true;
  isSending = false;
  nothingToPay = true;
  showThereAreOtherItemsToPay = false;
  splitType: string = "";
  allowSplit = false;
  amount: number = 0;
  isAnon?: boolean;
  selectedItems = {};
  inlineDonations?: any[];
  attrValues: { [key: string]: { [key: string]: string } } = {};
  isMessenger = false;
  showBackButton = true;
  showSplitButton = false;
  show_discount = false;
  loyaltyInfo?: UserSpecificConfigLoyalty;
  activeCode: string | undefined;

  data?: LivesplitData;
  chatItems: any[] = [];
  chatChildrenByRid: Record<string, any[]> = {};
  // Under a package with choices or part attributes: what its parts are
  chatPackageDetailsByRid: Record<string, string[] | null> = {};
  packageDetailsByRid: Record<string, string[] | null> = {};
  priceFormatted?: string;
  leftFormatted?: string;
  reservedByOthersFormatted?: string;
  groups?: LivesplitGroup[];
  left: number = 0;
  reservedByOthers: number = 0;
  lastRid?: string;
  config?: VenueConfig;
  tipAmount? = 0;
  tipButtonId = "0";
  tipConfig?: ActiveTipConfig;
  page= 1;
  singlePage?: boolean = undefined;
  showTip?: boolean = undefined;
  splitButtonTitle: string = 'Dela notan';
  hasExecutedLivesplitForDiscount = false;
  // The venue's language. Norwegian venues get the acceptance sentence by the pay buttons (Vipps requires the
  // guest to accept the terms before a payment starts); other venues keep the plain terms link.
  venueLang = "sv";

  private venueId!: string;
  private combinedSub?: Subscription;
  private order?: Order;
  private liveSub?: Subscription;
  private sub1?: Subscription;

  private totalPre: number = 0;
  private itemRefs: any[] = [];
  receiptKey?: string;
  private paymentLinkKey?: string;
  livesplitTable?: string;
  private setupOnce = false;
  private navUrlHack?: string;
  appState?: AppState;
  private myId: number | undefined;
  private paymentInProgressDoNotListenForStateUpdates = false;

  constructor(private route: ActivatedRoute, private api: AuthorizedApiService, private identityService: UrlHistoryService,
              private orderService: OrderService, private router: Router, public modalService: ModalService, private appStateService: AppStateService,
              private fire: FireService, private snackbar: SnackbarService, private messengerService: MessengerService,
              private menu: MenuService, public translate: TranslateService, private auth: AuthService,
              private paymentService: PaymentService, private viewportService: ViewportService, private themeService: ThemeService,
              private paymentSessionService: PaymentSessionService, private tipService: TipService) { }

  ngOnInit(): void {
    this.init();
    // this.route.paramMap.subscribe(data => {
    //   this.venueId = data.get("venue_id");
    //   const key = data.get("receipt_key");
    //   this.receiptKey = key == null ? undefined : key;
    // });
  }

  ngOnDestroy(): void {
    this.combinedSub?.unsubscribe();
    this.liveSub?.unsubscribe();
    this.sub1?.unsubscribe();
  }

  private init() {
    this.combinedSub = combineLatest([
      this.route.paramMap,
      this.appStateService.observeAppState()]
    ).subscribe(res => {
      if (this.paymentInProgressDoNotListenForStateUpdates) {return;}
      const pm = res[0];
      this.appState = res[1];
      this.venueId = this.appState.venueId.toString();
      this.order = this.appState.order;
      this.config = this.appState.cfg;
      this.venueLang = LangUtils.venueLanguage(this.config);

      const loyInfo = this.appState?.order?.user_cfg?.loyalty_card;
      this.setupLoyalityProps(loyInfo);

      this.isMessenger = this.messengerService.isMessenger(this.order);

      let updated = !this.setupOnce;
      const receiptKey = pm.get("receipt_key");
      const rkey = receiptKey == null ? undefined : receiptKey;
      if (rkey !== this.receiptKey) {
        this.receiptKey = rkey;
        updated = true;
      }
      const paymentLinkKey = pm.get("pl_key");
      const pkey = paymentLinkKey == null ? undefined : paymentLinkKey;
      if (pkey !== this.paymentLinkKey) {
        this.paymentLinkKey = pkey;
        updated = true;
      }

      const isAnon = this.appState.order.user_cfg.is_anon;
      if (this.isAnon != null && this.isAnon !== isAnon) {
        console.log("User has changed from anon to not anon or vice versa, setting up livesplit again");
        updated = true;
      }
      this.isAnon = isAnon;
      if (updated) {
        this.setupLiveSplitState();
      }
      this.myId = this.appState?.order.user_cfg.user_id;
    });

    this.sub1 = this.paymentSessionService.observePaymentSession().subscribe(session => {
      if (this.paymentInProgressDoNotListenForStateUpdates) {return;}

      // resolve split button title and state
      this.splitButtonTitle = session?.hasOtherItemsToPay?'Se hela notan':'Dela notan';
      this.showThereAreOtherItemsToPay = session?.hasOtherItemsToPay===true;

      // If we are in non livesplit mode and the payment session indicates that we should be
      const notInLivesplit = this.splitType !== "livesplit";
      if ((session?.isLivesplitActive || session?.tableItemsToPay) && notInLivesplit) {
        console.log("Payment session indicates livesplit is active, setting up livesplit...");
        this.setupLiveSplitState();
      }
    });
  }

  private setupLiveSplitState() {

    this.liveSub?.unsubscribe();
    this.setupOnce = true;
    this.api.livesplitData(this.receiptKey, this.paymentLinkKey).subscribe(r => {
      this.livesplitTable = r.table;
      console.log('Livesplit data:', r);
      this.splitType = r.split_type;
      const wildcardItem = this.wildcardItemForTipService();
      const interfaceType = r.split_type === 'pl' ? 'payment_link' : 'livesplit';
      const tipConfig = this.tipService.getTip(this.appState!, [wildcardItem], interfaceType, r.allow_tip === false);
      if (tipConfig) {
        this.tipConfig = tipConfig;
      } else {
        // Old behavior without tip config
        this.tipConfig = this.tipService.getTipConfigWhenMissingConfig(r.allow_tip === false, this.order?.user_cfg?.payment?.use_tip);
      }
      this.showTip = this.tipConfig.tipActive;
      this.tipAmount = this.tipConfig.defaultTip;
      this.tipButtonId = this.tipConfig.defaultButtonId;

      if (r.split_type === 'chat' || r.split_type === 'pl') {
        this.isLoading = false;
        this.data = r;
        this.setupChatItemsForDisplay(r.items ?? []);
        this.amount = r.amount;
        this.priceFormatted = MoneyUtils.formatNoCents(this.amount+(this.tipAmount??0));
        this.nothingToPay = this.amount === 0;
        this.allowSplit = r.allow_split === true;
        this.singlePage = !this.showTip && !this.show_discount;
        this.showBackButton = this.paymentLinkKey == null;
        this.showSplitButton = this.allowSplit;
      } else if (r.split_type === 'livesplit') {
        this.beginObservingLivesplitData(r.table);
        this.singlePage = false;
        this.showSplitButton = false;
      }
      this.setupLoyalityProps(r.loyalty_card, r.discount_code);
    });

    this.setupDonations();
  }

  private setupChatItemsForDisplay(items: any[]) {
    this.chatItems = [];
    this.chatChildrenByRid = {};
    this.chatPackageDetailsByRid = {};
    // Drop package component rows, keep the package placeholder (same as shouldItemBeVisible)
    const filtered = items.filter(i => i.package == null || i.package.aggregated_cent != null);
    const menuStruct = this.menu.getMenuStructure();
    for (const item of filtered) {
      if (item.package) {
        this.chatPackageDetailsByRid[item.rid] = MenuUtils.packageDetailLines(item, items, menuStruct);
      }
    }
    for (const item of filtered) {
      const isChild = item.parent_rid && (item.included === true || item.mandatory === true);
      if (isChild) {
        (this.chatChildrenByRid[item.parent_rid] ??= []).push(item);
      } else {
        this.chatItems.push(item);
      }
    }
  }

  public shouldItemBeVisible(item: any): boolean {
    if(item.package) {
      return item.package.aggregated_cent != null;
    }
    return true;
  }

  public getPrice(item: any): number {
    if(item.package && item.package.aggregated_cent != null) {
      return item.package.aggregated_cent / 100;
    }
    return item.price;
  }

  public backClicked() {
    console.log("Back clicked, page:", this.page);
    if (this.page === 1) {
      this.identityService.navigateBack();
    } else {
      this.resetExecutedDiscount();
      this.page -= 1;
      this.showBackButton = this.paymentLinkKey == null || this.page > 1;
    }
  }

  //////////////////////////
  // LIVESPLIT RELATED
  //////////////////////////

  activateSplit() {
    console.log("Add to split...");
    this.isLoading = true;

    this.api.activateLivesplit(this.paymentLinkKey).subscribe(r => {
      console.log("Activated livesplit successfully");
      this.livesplitTable = r.table;
      this.splitType = "livesplit";
      this.showSplitButton = false;
      if (this.data != null ) {
        // clear discounts if livesplit is activated
        this.data!.discount_code = undefined;
        this.data!.total_discount = undefined;
      }
      this.beginObservingLivesplitData(r.table);
    }, error => {
      this.isLoading = false;
    });
  }

  private beginObservingLivesplitData(table: string) {
    console.log(`Observe table: ${table}`);
    this.liveSub?.unsubscribe();
    this.liveSub = this.fire.observeLivesplit(table, Number(this.venueId)).subscribe(ls => {
      if (this.paymentInProgressDoNotListenForStateUpdates) {return;}
      // While a discount receipt is active, snapshots must not overwrite the discounted amount/itemRefs
      if (this.hasExecutedLivesplitForDiscount) {return;}
      if (ls == null) {
        console.warn("Livesplit data is missing");
        this.nothingToPay = true;
        this.isLoading = false;
        return;
      }
      const groups = this.groupPaymentData(ls);
      this.groups = this.sortGroups(groups, this.order!.user_cfg.user_id!.toString());
      this.priceFormatted = MoneyUtils.formatNoCents(this.amount+(this.tipAmount??0));
      this.leftFormatted = MoneyUtils.formatNoCents(this.left);
      this.reservedByOthersFormatted = MoneyUtils.formatNoCents(this.reservedByOthers);
      console.log("Groups:", this.groups);

      this.isLoading = false;
    });
  }

  private addRowToCurrentSelected(row: any) {
    const count = row.count ?? 1;
    const priceSum = row.price * count;
    const prePriceSum = (row.pre_price ?? row.price) * count;
    this.amount += priceSum;
    this.totalPre += prePriceSum;
    this.itemRefs.push(`${row.ok}|${row.rid}`);
  }

  private groupPaymentData(data: any) {
    console.log("Document data:", data);
    const userId = this.order!.user_cfg.user_id;
    console.log("this.userId:", userId);

    this.amount = 0;
    this.totalPre = 0;
    this.left = 0;
    this.reservedByOthers = 0;
    this.itemRefs = [];
    const groups = [];
    const groupCount = data.groups;
    this.nothingToPay = groupCount === 0;
    for (let i = 0; i < groupCount; i++) {
      const group = data["group" + i];
      const rids = group.rids.split(",");
      const items = [];
      let allSelected = true;
      for (const rid of rids) {
        const row = data["rid" + rid];
        const isMine = userId === row.user_id;
        if (row.state === "paid") {
          row.canChange = false;
        } else {
          if (row.state === "reserved") {
            row.canChange = isMine;
            if (isMine) {
              this.addRowToCurrentSelected(row);
            } else {
              this.reservedByOthers += (row.count ?? 1) * row.price;
            }
          } else {
            const count = row.count ?? 1;
            const priceSum = count * row.price;
            this.left += priceSum;
            row.canChange = true;
            allSelected = false;
          }
        }

        row.selected = row.state === "paid" || row.state === "reserved";
        items.push(row);
      }
      group.selected = allSelected;
      group.items = items;
      group.jointNote = group.user_id.includes("-");
      group.isMine = group.user_id === userId!.toString();
      groups.push(group);
    }
    const allRows = groups.flatMap(g => g.items);
    const menuStruct = this.menu.getMenuStructure();
    this.packageDetailsByRid = {};
    for (const row of allRows) {
      if (row.package?.aggregated_cent != null) {
        this.packageDetailsByRid[row.rid] = MenuUtils.packageDetailLines(row, allRows, menuStruct);
      }
    }
    console.log("Grouped data", groups);
    return groups;
  }

  itemToggled(item: any) {
    if(!item.canChange) {
      return;
    }
    item.selected = !item.selected;
    this.itemSelected(item);
  }

  itemSelected(item: any) {
    console.log("itemSelected", item);
    this.isSending = true;
    const docRef = this.fire.getLivesplitDocRef(this.livesplitTable!, Number(this.venueId));
    const affectedItems = this.groups!.flatMap(g => g.items.filter(i => {
      // Check if the item's package is not null and matches the selected item's package pid
      // or if the item's package is null, check if the item's rid matches the selected item's rid
      return (item.package && i.package && item.package.pid === i.package.pid) || (!item.package && i.rid === item.rid);
    }));

    console.log("Affected Items", affectedItems);
    this.fire.runTransaction(transaction => {
      // This code may get re-run multiple times if there are conflicts.
      // @ts-ignore
      return transaction.get(docRef).then( doc => {
        if (!doc.exists) {
          this.isSending = false;
          throw new Error("Document does not exist!");
        }
        // Do for all affected items
        const data = doc.data();
        const d = {};
        for (const affectedItem of affectedItems) {

          const rowName = "rid" + affectedItem.rid;
          const orgRowData = data[rowName];
          const reserve = item.selected;

          //Check has correct state
          const orgIsOpen = orgRowData.state == null || orgRowData.state === "open";
          const orgIsReserved = orgRowData.state === "reserved";
          if (reserve && !orgIsOpen || !reserve && !orgIsReserved) {
            console.log("Race condition, and you lost!");
            transaction.update(docRef, {});
            this.snackbar.showMessage("Oj den hann bli reserverad!");
            return;
          }

          if (reserve) {
            orgRowData.state = "reserved";
            orgRowData.user_id = this.order!.user_cfg.user_id;
            orgRowData.user = this.order!.user_cfg.user_name;
          } else {
            orgRowData.state = "open";
            orgRowData.user_id = 0;
            orgRowData.user = "";
          }

          // @ts-ignore
          d[rowName] = orgRowData;
        }
        transaction.update(docRef, d);
      });
    }).then( () => {
      if (item.selected) {
        this.lastRid = item.rid;
      }
      this.isSending = false;
      console.log("Transaction successfully committed!");
    }).catch( error => {
      this.snackbar.showMessage("Gick inte att reservera artikeln");
      this.isSending = false;
      item.selected = !item.selected;
      console.log("Transaction failed: ", error);
    });
  }

  selectAll(group: LivesplitGroup) {
    console.log("selectAll", group);
    this.isSending = true;
    const changeToState = group.selected ? "open" : "reserved";
    const currentState = group.selected ? "reserved" : "open";
    // @ts-ignore
    const docRef = this.fire.getLivesplitDocRef(this.livesplitTable!, Number(this.venueId));

    this.fire.runTransaction(transaction => {
      // This code may get re-run multiple times if there are conflicts.
      // @ts-ignore
      return transaction.get(docRef).then( doc => {
        if (!doc.exists) {
          this.isSending = false;
          throw new Error("Document does not exist!");
        }

        const d: Record<string, any> = {};
        for (const item of group.items) {
          const rowName = "rid" + item.rid;
          const data = doc.data();
          const orgRowData = data[rowName];

          //Check has correct state
          const okState = orgRowData.state == null || orgRowData.state === currentState;
          if (!okState) {
            continue;
          }
          if (changeToState === "open") {
            if (orgRowData.user_id !== this.order!.user_cfg.user_id) {
              continue;
            }
          }

          orgRowData.state = changeToState;
          orgRowData.user_id = this.order!.user_cfg.user_id;
          orgRowData.user = this.order!.user_cfg.user_name;
          d[rowName] = orgRowData;
        }

        transaction.update(docRef, d);
      });
    }).then( () => {
      this.isSending = false;
      console.log("Transaction successfully committed!");
    }).catch( error => {
      this.snackbar.showMessage("Gick inte att reservera");
      this.isSending = false;
      console.log("Transaction failed: ", error);
    });
  }

  splitItems(item: any) {
    const affectedItems = this.groups!.flatMap(g => g.items.filter(i => {
      // Check if the item's package is not null and matches the selected item's package pid
      // or if the item's package is null, check if the item's rid matches the selected item's rid
      return (item.package && i.package && item.package.pid === i.package.pid) || (!item.package && i.rid === item.rid);
    }));

    console.log("splitItems", item, affectedItems);
    this.openSplitItemsDialog(item, affectedItems).subscribe( btn => {
      console.log("Selected btn:", btn);
      if (btn) {
        this.isSending = true;
        const itemsToSplit = affectedItems.map(i => ({ orderKey: i.ok, rid: i.rid }));
        this.api.splitItems(itemsToSplit, btn.parts, this.paymentLinkKey).subscribe( r => {
          this.isSending = false;
        }, error => {
          console.log("Gick inte att dela", error);
          this.snackbar.showMessage("Gick inte att dela");
          this.isSending = false;
        });
      }
    });
  }

  openSplitItemsDialog(item: any, affectedItems: any[]): Observable<any> {
    const dialogRef = this.modalService.show(SplitItemDialogComponent, {
      data: { item, affectedItems }
    });
    return dialogRef;
  }

  async pay(method: string) {
    if(this.tipAmount == null) {
      return;
    }
    // Use the discounted receipt also in livesplit mode once a discount receipt has been created
    const payFullReceiptKey = this.data?.receipt_key != null && (this.splitType !== 'livesplit' || this.hasExecutedLivesplitForDiscount)
      ? this.data.receipt_key : undefined;
    const chargeItems = this.gatherChargeItems();

    if (method === "card") {
      method = await SelectCardDialogComponent.showSelectCardDialog(this.modalService, this.appState!);
    }

    const pid: PaymentInputData = {
      tipParam: "v"+this.tipAmount,
      method: method,
      chargeItems: chargeItems,
      declineRoute: "livesplit/paymentfailed",
      receipt_key: payFullReceiptKey,
      itemRefs: payFullReceiptKey == null ? this.itemRefs : undefined,
      // Payment link key as the wallet buttons already send it (plKeyForDirect); was missing for the other methods
      plKey: this.paymentLinkKey,
    };
    this.isLoading = true;
    try {
      this.paymentInProgressDoNotListenForStateUpdates = true;
      const pod = await this.paymentService.pay(pid);
      await this.handlePostPayment(pod);
    } catch (error) {
      this.paymentInProgressDoNotListenForStateUpdates = false;
      this.snackbar.showMessageForError(error);
      this.isLoading = false;
    } finally {
    }
  }
  // https://cn.heynow.ai/5079418695319552/paystatus/agxofmhleW5vd2JldGFyMAsSBFVzZXIYgICAmOKB-gkMCxISVXNlclBheW1lbnRSZWNlaXB0GICAgPrixYYJDA%3Fsec%3D30c33c90ee4637cc206d09521f7d85cb&uid%3DCUYbt2D7hLO5jz011dywAZ0gow43
  get currencySymbol(): string {
    return MoneyUtils.symbol();
  }

  get chargeItemsForDirect(): ChargeItem[] | undefined {
    return this.gatherChargeItems();
  }

  get plKeyForDirect(): string | undefined {
    return this.paymentLinkKey;
  }

  get receiptKeyForDirect(): string | undefined {
    return this.data?.receipt_key != null && (this.splitType !== 'livesplit' || this.hasExecutedLivesplitForDiscount)
      ? this.data.receipt_key : undefined;
  }

  get itemRefsForDirect(): any[] | undefined {
    return this.receiptKeyForDirect == null ? this.itemRefs : undefined;
  }

  async handleDirectPaymentComplete(event: { receiptKey: string }) {
    this.paymentInProgressDoNotListenForStateUpdates = true;
    await this.router.navigate([this.appStateService.venueId, 'paystatus', event.receiptKey]);
  }

  handleDirectPaymentFailed(error: any) {
    console.warn('Direct wallet payment failed', error);
    this.snackbar.showMessageForError(error);
  }

  private async handlePostPayment(pod: PaymentOutputData) {
    console.log('Payment result:', pod);
    if (pod.navUrl) {
      await this.router.navigateByUrl(pod.navUrl);
    } else if (pod.checkPayStatusReceiptKey) {
      await this.router.navigate([this.appStateService.venueId, 'paystatus', pod.checkPayStatusReceiptKey]);
    }
  }

  terms() {
    this.router.navigateByUrl(`${this.venueId}/terms`);
    return false;
  }

  private setupDonations() {
    if (this.receiptKey != null) {
      // Dont show donations if we are on a refill page
      return;
    }
    const menuStruct = this.menu.getMenuStructure();
    if (menuStruct && menuStruct.donation_items?.length > 0) {
      this.inlineDonations = menuStruct.donation_items;
    }
  }

  selectedChange(selectedItem: MenuItem) {
    // Setup default attribute values
    this.attrValues[selectedItem.id] = {};
    for (const atr of selectedItem.attributes ?? []) {
      if (!atr.hidden && !this.attrValues[selectedItem.id][atr.id]) {
        const opt = atr.options.find(o => o.default) ?? (atr.options.length > 1 ? atr.options[0] : undefined);
        if (opt) {
          this.attrValues[selectedItem.id][atr.id] = opt.key;
        }
      }
    }
  }

  private gatherChargeItems(): ChargeItem[] | undefined {
    const menuStruct = this.menu.getMenuStructure();
    const itemIds = MenuUtils.collectSelectedItemIds(this.selectedItems, this.attrValues, menuStruct);
    if (itemIds.length === 0) {
      return undefined;
    }
    const chargeItems = itemIds.map( itemId => ({item_id: itemId}) );
    console.log("Collected charge items", chargeItems);
    return chargeItems;
  }

  getString(s: string, pc: string = "normal") {
    return this.translate.single(s, pc);
  }

  private sortGroups(groups: any[], userId: string): any[] {
    // Sort first groups with jointNote === True
    // Then group where isMine === True
    // Then the rest by name

    const groupsWithJointNote = groups.filter(g => g.jointNote);
    // update name to "Gemensam nota" if theres only one group
    // update name to "Gemensam nota ({old name})" if there is more than one group
    if (groupsWithJointNote.length === 1) {
      groupsWithJointNote[0].name = this.getString("Gemensam nota");
    } else {
      for (const group of groupsWithJointNote) {
        group.name = this.getString("Gemensam nota") + ` (${group.name})`;
      }
    }

    const guestCount = groups.length - groupsWithJointNote.length;
    //Set hint to "Beställningar som du delar med andra"
    for (const group of groupsWithJointNote) {
      if (guestCount < 2) {
        group.hint = this.getString("Beställningar via personalen");
      } else {
        group.hint = this.getString("Beställningar som du delar med andra");
      }
    }

    const groupsWithUser = groups.filter(g => g.isMine);
    for (const group of groupsWithUser) {
      group.hint = this.getString("Dina beställningar");
    }

    const groupsWithoutUser = groups.filter(g => !g.jointNote && g.user_id !== userId);

    groupsWithJointNote.sort((a, b) => a.name.localeCompare(b.name));
    groupsWithUser.sort((a, b) => a.name.localeCompare(b.name));
    groupsWithoutUser.sort((a, b) => a.name.localeCompare(b.name));
    return groupsWithJointNote.concat(groupsWithUser).concat(groupsWithoutUser);
  }

  nextPage() {
    this.page = 2;
    this.viewportService.killMomentumAndScrollToTop();
    this.showBackButton = this.paymentLinkKey == null || this.page > 1;
  }

  handleTipChange($event: TipChangeEvent) {
    this.tipAmount = $event.amount;
    this.tipButtonId = $event.buttonId;
    this.priceFormatted = MoneyUtils.formatNoCents(this.amount + this.tipAmount);
  }

  getUserName(item: any) {
    if (item.user_id == this.myId) {
      return this.translate.getString("dig");
    }
    return item.user;
  }

  showDiscountDialog() {
    if (this.splitType === 'livesplit') {
      // We  need to execute and create a receipt first
      this.api.executeLivesplit(this.itemRefs).subscribe(
        (result) => {
          this.setupLoyalityProps(result.loyalty_card, result.discount_code)
          this.hasExecutedLivesplitForDiscount = true;
          console.log('Executed livesplit successfully:', result);
          // @ts-ignore
          this.data = result;
          this.doShowDiscountDialog();
        },
        (err) => {
        }
      );
      return;
    }

    this.doShowDiscountDialog();
  }

  doShowDiscountDialog() {
    const dialogRef = this.modalService.show(EnterDiscountCodeDialogComponent, {
      data: { receiptKey: this.data?.receipt_key, type: "receipt" },
      closeOnBackdrop: false,
    });

    dialogRef.subscribe((result) => {
      if (result) {
        console.log('Discount code activated/added:', result);

        this.data = result;
        this.amount = result.amount;
        if (result.amount === 0) {
          // Free receipt: tip cannot be charged on a 0 kr payment
          this.tipAmount = 0;
        }
        this.priceFormatted = MoneyUtils.formatNoCents(this.amount + (this.tipAmount??0));
        // A fully discounted receipt is not "all paid" — keep the pay section visible for the free-completion button
        this.nothingToPay = this.amount === 0 && this.data?.receipt_key == null;
      }
    });
  }

  discountApplied() {
    return this.data?.discount_code != null;
  }

  // True when a receipt exists for the current bill/selection and it is fully discounted (0 kr)
  get isFreeDiscountedReceipt(): boolean {
    return this.data?.receipt_key != null && this.data?.amount === 0;
  }

  discountAmount() {
    return MoneyUtils.formatNoCents(this.data?.total_discount ?? 0);
  }

  private resetExecutedDiscount() {
    if (this.hasExecutedLivesplitForDiscount && this.data!=null) {
      console.log("Resetting livesplit receipt key and discount code");
      // Reset the receipt key to null, this will drop the receipt, drop the receipt => discount has to be added again
      // @ts-ignore
      this.data!.receipt_key = null;
      // @ts-ignore
      this.data!.discount_code = undefined;
      // @ts-ignore
      this.data!.total_discount = undefined;
      this.hasExecutedLivesplitForDiscount = false;
      this.setupLiveSplitState();
    }
  }

  activateLoyaltyDiscount(dc: UserSpecificConfigLoyaltyDiscountCode) {
    if (!this.preLoyaltyActivate(dc)) {
      return;
    }

    console.log("activateLoyaltyDiscount", dc);
    // If receiptKey exists, use activateDiscountCode
    this.api.activateDiscountCode(dc.code, this.data!.receipt_key!).subscribe(
      (result) => {
        this.afterSuccessfulLoyaltyActivate(result);
      },
      (err) => {
        this.snackbar.showMessageForError(err);
      }
    );

  }

  activateLoyaltyReward(rewardTrigger: UserSpecificConfigLoyaltyRewardTrigger) {
    if (!this.preLoyaltyActivate(undefined, rewardTrigger)) {
      return;
    }

    console.log("activateLoyaltyReward", rewardTrigger);
    this.api.activateRewardReceipt(this.loyaltyInfo!.key!, rewardTrigger.id, this.data!.receipt_key!).subscribe(
      (r) => {
        this.afterSuccessfulLoyaltyActivate(r);
      },
      (err) => {
        this.snackbar.showMessageForError(err);
      }
    );
  }

  private setupLoyalityProps(loyInfo: UserSpecificConfigLoyalty | undefined, activeCode?: string) {
    console.log("loyInfo", loyInfo);
    if (loyInfo) {
      this.loyaltyInfo = loyInfo;
      this.show_discount = false;
      this.activeCode = activeCode;
    } else {
      this.show_discount = this.appState?.cfg?.show_discount == true;
      this.loyaltyInfo = undefined;
      this.activeCode = undefined;
    }
  }

  private afterSuccessfulLoyaltyActivate(r: LivesplitData) {
    this.setupLoyalityProps(r.loyalty_card, r.discount_code)
    this.hasExecutedLivesplitForDiscount = true;
    console.log('Executed livesplit successfully:', r);
    // @ts-ignore
    this.data = r;
    this.amount = r.amount;
    if (r.amount === 0) {
      // Free receipt: tip cannot be charged on a 0 kr payment
      this.tipAmount = 0;
    }
    this.priceFormatted = MoneyUtils.formatNoCents(this.amount + (this.tipAmount??0));
  }

  private preLoyaltyActivate(dc?: UserSpecificConfigLoyaltyDiscountCode, rewardTrigger?: UserSpecificConfigLoyaltyRewardTrigger) {
    if (this.data?.receipt_key != null) {
      // We have a receipt, good to go
      return true;
    }

    this.api.executeLivesplit(this.itemRefs).subscribe(
      (result) => {
        this.setupLoyalityProps(result.loyalty_card, result.discount_code)
        this.hasExecutedLivesplitForDiscount = true;
        console.log('Executed livesplit successfully:', result);
        // @ts-ignore
        this.data = result;

        if (dc != null) {
          this.activateLoyaltyDiscount(dc);
        }
        if (rewardTrigger != null) {
          this.activateLoyaltyReward(rewardTrigger);
        }

      },
      (err) => {
      }
    );

    return false;
  }

  // When tip rule is decided, this function creates a wildcard OrderItem to pass to the tip service
  private wildcardItemForTipService(): OrderItem {
    // @ts-ignore
    return {
      item: '*',
    }
  }
}
